var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuineaPig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,36.2c0,0,4.9,0.2,7.5,1.7c4.6,2.6,6.9,7.2,5.1,10.3c-1.8,3.1-6.9,3.4-11.5,0.8c-2-1.1-3.6-2.7-4.5-4.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 85.7,
    cy: 48.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.2,74.7l-19.5,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.9,54.3c10.2,14.2-3.6,20.5-3.6,20.5H13.9c0,0-7.4-3.4-7.1-11.5C8,38.5,29.1,40.1,38.7,42.2 c3.2,0.7,6.5,0.4,9.6-0.8c5.9-2.4,15.8-6,21.6-6c8.6,0,28.4,9.5,27.3,18.6c-0.6,5.4-6.9,7.7-11.9,8.8c-4.7,1-8.2,2-11.9,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.2,69.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.6,67.2c1.9,0,5.6,1.7,6.6,2.9c1.7,1.8,0.4,4.8-2.1,4.8H30.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.9,74.8h11.9c2.5,0,3.8-2.9,2.1-4.8c-1.1-1.2-8.3-0.7-11.5-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.2,74.7c0,0-5.2-5.7-6.6-10.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuineaPig);
export default __webpack_public_path__ + "static/media/guineaPig.7b0e22fd3f5bbdaec99dd2bff1b9481b.svg";
export { ForwardRef as ReactComponent };